import { render, staticRenderFns } from "./secondAndMinute.vue?vue&type=template&id=73392983&scoped=true"
import script from "./secondAndMinute.vue?vue&type=script&lang=js"
export * from "./secondAndMinute.vue?vue&type=script&lang=js"
import style0 from "./secondAndMinute.vue?vue&type=style&index=0&id=73392983&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73392983",
  null
  
)

export default component.exports